export * from './vendedor-slice'